var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vs-switch",
        {
          on: {
            change: function($event) {
              return _vm.changeValue()
            }
          },
          model: {
            value: _vm.valueMutable,
            callback: function($$v) {
              _vm.valueMutable = $$v
            },
            expression: "valueMutable"
          }
        },
        [
          _c("span", { attrs: { slot: "on" }, slot: "on" }, [
            _vm._v(_vm._s(_vm.config.label_true))
          ]),
          _c("span", { attrs: { slot: "off" }, slot: "off" }, [
            _vm._v(_vm._s(_vm.config.label_false))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }